<template>
    <div class="chat-box">
        <div v-for="message in messages.filter(m => hide.indexOf(m) == -1).filter(m => !m.response)" class="chat-message">
            <p>{{ formatDistance(Date.now(),message.created,{ includeSeconds: true }) }}</p> 
            <p>{{ message.name }}</p>
            <p>{{ message.email }}</p>
            <p class="chat-content">{{ message.message }}</p>
            <p class="btn sm" @click="doneMessage(message)">done</p>
            <div class="x" @click="hide.push(message)"></div>
        </div>
        <div class="count-box">
            <p class="btn sm" @click="switchHide">show</p>
            <p class="count-message">({{ messages.filter(m => !m.response).length }})</p>
        </div>
    </div>
</template>

<script>

import { format, formatDistance } from 'date-fns'
import WebSoc from '@/utils/WebSoc.js';
import { mapActions } from 'vuex';

export default {
    props: ['messages'],
    computed: {
        staff_id () { return this.$store.state.staff_id },
        name () { return this.$store.state.name }
    },
    data () {
        return {
            hide: [],
            formatDistance,
        }
    },
    mounted () {
        setInterval(() => {
            var minute = Date.now() -  ( 1000 * 35 );
            var recent = this.messages.find(m => { return minute - m.created < 0 });
                recent && this.$forceUpdate();
        },3000);
    },
    methods: {
        switchHide () {
            if ( this.hide.length > 0 ) { 
                this.hide = [];
                this.getMessages();
                return;
            }
            this.messages.forEach(m => this.hide.push(m));
        },
        doneMessage ( message ) {
            var now = Date.now();
            WebSoc.SEND('update',{ DB: 'messages', _id: message._id, update: { $set: { response: true, responded: now, staffName: this.name }, $push: { ['dStaff.'+this.staff_id]: now } } },resp => {
                console.log('done !!');
            })
        },
        ...mapActions([
            'getMessages'
        ])
    }
}

</script>

<style lang="scss">
.chat-box {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 200px;
    .chat-message {
        width: calc(100% - 10px);
        display: inline;
        float: left;
        position: relative;
        background-color: rgba(191, 235, 155,1);
        margin: 5px;
        p {
            font-size: 12px;
            margin: 3px;
            &.chat-content {
                font-weight: bold;
            }
        }
        div.x { position: absolute; right: -3px; top: 0px; width: 42px; height: 42px; transform: scale(0.3) translate(33px,-42px); background-color: rgba(107, 199, 32,1); border: 2px solid green; border-radius: 50%; }
        div.x:before,div.x:after { content: ''; width: 45px; height: 2px; background-color:green; position: absolute; top: 19px; }
        div.x:before { transform: rotate(45deg) translate(-1px,1px); }
        div.x:after { transform: rotate(-45deg) translateX(-2px); }
    }
    .btn.sm {
        position: relative;
        float: right;
        font-size: 12px;
        line-height: 15px;
        width: 40px;
    }
    .count-box {
        p { font-size: 12px; float: right; }
        .count-message {
            line-height: 24px;
        }
        
    } 
}
</style>